import React, { useState } from 'react';

const TextArea = ({ title, className = '', onChange, value = '', name }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className={`relative mb-5 min-w-32 ${className}`} dir="rtl">
      <textarea
          name={name}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(value !== '')}
          className="w-full px-4 pt-5 pb-2 text-md bg-light-bg border-2 border-gray-200 rounded-md appearance-none transition-all peer min-h-20 text-right"
      />
            <label
                className={`absolute right-4 text-gray-500 text-md transition-all bg-light-bg px-1 ${
                    isFocused || value ? '-top-2 text-xs text-light-primary dark:text-dark-primary' : 'top-4'
                }`}
            >
                {title}
            </label>
        </div>
    );
};

export default TextArea;
